/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Membership_Interval_YearInputs */

const fr_membership_interval_year = /** @type {(inputs: Membership_Interval_YearInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`an`)
};

/**

* @param {Membership_Interval_YearInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const membership_interval_year = /** @type {((inputs?: Membership_Interval_YearInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Membership_Interval_YearInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_membership_interval_year(inputs)
});